import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';
import { MessagePlugin } from 'tdesign-vue-next';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/softwarelibrary',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/chooseidentity',
        name: 'ChooseIdentity',
        component: () => import('../views/ChooseIdentity.vue') // 选择认证身份
      },
      {
        path: '/personalconfirm',
        name: 'PersonalConfirm',
        component: () => import('../views/PersonalConfirm.vue') // 个人开发者 身份认证
      },
      {
        path: '/personaledit',
        name: 'PersonalEdit',
        component: () => import('../views/PersonalEdits.vue') // 个人开发者 身份信息编辑
      },
      {
        path: '/companyconfirm',
        name: 'CompanyConfirm',
        component: () => import('../views/CompanyConfirm.vue') // 企业开发者 身份认证
      },
      {
        path: '/companyedit',
        name: 'CompanyEdit',
        component: () => import('../views/CompanyEdits.vue') // 企业开发者 身份信息编辑
      },
      {
        path: '/softwarelibrary',
        name: 'SoftwareLibrary',
        component: () => import('../views/SoftwareLibrary.vue') // 主页 软件list展示
      },
      {
        path: '/deveaddsoftware',
        name: 'DeveAddSoftware',
        component: () => import('../views/DeveAddSoftware.vue') // 新增软件页面
      },
      /**
       * 更新软件的逻辑需要区分是：上架过的软件更新，和第一次上架软件的更新
       * 第一次上架软件需要校验的东西更多，软著，专利等等
       * */
      {
        path: '/softwareupdate/:softwareId',
        name: 'SoftwareUpdate',
        component: () => import('../views/SoftwareUpdate.vue') // 更新软件 - 上架过的软件进行更新
      },
      {
        path: '/addnewsoftware/:softwareId',
        name: 'AddNewSoftware',
        component: () => import('../views/AddNewSoftware.vue') // 更新软件 - 第一次上架软件的更新
      },
      {
        path: '/addnewversion/:softwareId',
        name: 'AddNewVersion',
        component: () => import('../views/AddNewVersion.vue') // 添加新版本
      },
      {
        path: '/useragreement',
        name: 'UserAgreement',
        component: () => import('../views/UserAgreement.vue') // 用户协议
      },
      {
        path: '/contactus',
        name: 'ContactUs',
        component: () => import('../views/ContactUs.vue') // 联系我们
      },
      // feedback
      {
        path: '/feedback/:page_type',
        name: 'Feedback',
        component: () => import('../views/Feedback.vue') // 操作反馈页
      },
      {
        path: '/softwaredetails/:softwareId',
        name: 'SoftwareDetails',
        component: () => import('../views/SoftwareDetails.vue') // 软件详情
      },
      {
        path: '/adSoftwareLibrary',
        name: 'AdSoftwareLibrary',
        component: () =>
          import('../views/AdSoftwareLibrary/AdSoftwareLibrary.vue') // 商包软件库
      },
      {
        path: '/editadsoftware',
        name: 'EditAdSoftware',
        component: () => import('../views/AdSoftwareLibrary/EditAdSoftware.vue') // 新增/编辑广告计划
      }
    ]
  },
  {
    path: '/proxy',
    name: 'Proxy',
    component: () => import('../views/Proxy.vue') // 扫码登陆 回调url 登陆逻辑处理页
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('../views/Verify.vue') // 实名认证 回调url 认证逻辑处理页
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  }
];

const currentEnv = process.env.NODE_ENV;
const router = createRouter({
  history:
    currentEnv === 'development'
      ? createWebHistory()
      : createWebHistory('software-platform'),
  routes
});

// 路由拦截  如果没有登录，只能进入登录页面
// router.beforeEach(to => {
//   const token: string | null = localStorage.getItem('token');
//   // 需要登陆才能访问的页面
//   const noAllowPath = [
//     '/chooseidentity', '/personalconfirm', '/companyconfirm', '/softwarelibrary',
//     '/deveaddsoftware', '/softwareupdate', '/softwaredetails', '/personaledit',
//     '/companyedit', '/addnewversion'
//   ];
//   if (!token && noAllowPath.indexOf(to.path) > -1) {
//     return '/login';
//   }
// });

// 没有登录不允许访问
const noAllowPathLogin = [
  'chooseidentity',
  'personalconfirm',
  'companyconfirm',
  'softwarelibrary',
  'deveaddsoftware',
  'softwareupdate',
  'addnewsoftware',
  'softwaredetails',
  'personaledit',
  'companyedit',
  'addnewversion',
  'adSoftwareLibrary',
  'editadsoftware'
];

// confirmed:0 认证被驳回 企业用户不允许访问
const noAllowPathUnConfirmedCom = [
  'deveaddsoftware',
  'softwareupdate',
  'addnewsoftware',
  'softwaredetails',
  'personalconfirm',
  'companyconfirm',
  'personaledit',
  'addnewversion'
];

// confirmed:0 认证被驳回 个人用户不允许访问
const noAllowPathUnConfirmedPer = [
  'deveaddsoftware',
  'softwareupdate',
  'addnewsoftware',
  'softwaredetails',
  'personalconfirm',
  'companyconfirm',
  'companyedit',
  'addnewversion'
];

// confirmed:1 审核中 个人用户不允许访问
const noAllowPathPerson = [
  'companyconfirm',
  'companyedit',
  'chooseidentity',
  'personaledit',
  'personalconfirm'
];

// confirmed:3 认证过的新用户 没有提交注册信息的用户不允许访问
const noIdentityUser = [
  'deveaddsoftware',
  'softwareupdate',
  'addnewsoftware',
  'softwaredetails',
  'addnewversion',
  'softwarelibrary',
  'companyedit',
  'personaledit'
];

router.beforeEach((to) => {
  const pathtemp = to.path.split('/')[1];

  const token: string | null = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  let tempUser: any = {};
  let confirmed = 0;
  let identityType = 0;
  if (userStr) {
    tempUser = JSON.parse(userStr);
    confirmed = tempUser.confirmed;
    identityType = tempUser.identityType;
  }

  // 如果没有登录 并且访问以下路由 跳转登录页
  if (!token && noAllowPathLogin.indexOf(pathtemp) > -1) {
    return '/login';
  }
  // confirmed 0-驳回认证；1-审核中；2-已认证；3-新用户

  // 如果是未认证过的新用户 跳转身份选择页面
  if (confirmed == 3 && noIdentityUser.indexOf(pathtemp) > -1) {
    MessagePlugin.error('请选择开发者认证方式！', 2000);
    return '/chooseidentity';
  }

  // 如果认证被驳回 个人用户 访问以下路由 跳转主页面
  if (
    confirmed == 0 &&
    identityType == 1 &&
    noAllowPathUnConfirmedPer.indexOf(pathtemp) > -1
  ) {
    MessagePlugin.error('您暂时无权访问该页面！', 2000);
    return '/';
  }

  // 如果认证被驳回 企业用户 访问以下路由 跳转主页面
  if (
    confirmed == 0 &&
    identityType == 2 &&
    noAllowPathUnConfirmedCom.indexOf(pathtemp) > -1
  ) {
    MessagePlugin.error('您暂时无权访问该页面！', 2000);
    return '/';
  }

  // 审核中 的用户 既不能编辑也不能重新认证
  if (confirmed == 1 && noAllowPathPerson.indexOf(pathtemp) > -1) {
    MessagePlugin.error('您暂时无权访问该页面！', 2000);
    return '/';
  }
});

export default router;
